
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources-for-solution-providers",
      function () {
        return require("private-next-pages/resources-for-solution-providers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources-for-solution-providers"])
      });
    }
  